import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { TransactionSortProperty } from '@features/transactions/enums/transactionSortProperty'
import { getTransactionsQueryKey } from '@features/transactions/utils/getTransactionsQueryKey'

import { fetchTransactions } from '../../../../../../transactions'

export const useInvoiceTransactions = (originatorReference?: string) => {
  const queryProps = useMemo(
    () => ({
      originatorReference,
      sortProperty: TransactionSortProperty.TransactionNo,
      withCreator: true,
      withVoided: true,
    }),
    [originatorReference],
  )

  const queryKey = useMemo(() => getTransactionsQueryKey(queryProps), [queryProps])

  const { data, isLoading } = useQuery(queryKey, () => fetchTransactions(queryProps), {
    enabled: !!originatorReference,
  })

  const { transactions } = data || {}

  return {
    transactions,
    isLoading,
  }
}
